<template>
  <div class="delivery-content outlined rounded-lg p-4 mb-4 bg-white">
    <div class="clearfix">
      <h2 class="h5 float-left">
        Delivery dates
        <div v-if="isAdmin">
          <button
            v-if="rates[0].offer_type == 'fixed'"
            class="btn btn-sm btn-info"
            type="button"
            @click="debug()"
          >
            Show admin info&nbsp;<i class="far fa-info-circle"></i>
          </button>
          <a
            v-else
            class="btn btn-sm btn-info"
            :href="
              '/dispatch/resources/pricing-responses/' + this.pricingResponseId
            "
            target="_blank"
            >Show admin info&nbsp;<i class="far fa-info-circle"></i
          ></a>
        </div>
      </h2>
      <div
        class="info float-right"
        style="display:none"
        v-tooltip:top="[
          '<h6>Delivery time</h6>The delivery dates and rates available for your freight.',
          true
        ]"
      >
        <i class="far fa-info-circle"></i>
      </div>
    </div>

    <div
      v-if="!pickupRestriction && sameRegion && moment().format('k') > 13"
      class="alert alert-warning"
    >
      Your freight may not be picked up today, however it will be delivered by
      your specified delivery date.
    </div>

    <!-- A message that shows up if the customer has offers that can be done by courier -->
    <div v-if="courierRates.length > 0">
      <p class="text-muted mb-4">
        Your freight is most efficiently delivered by courier. We estimate your
        freight will be delivered on the date shown.<br />
        Your package can be up to 2.4m long (1.5m for rural delivery)<br />
      </p>
    </div>
    <p v-else class="text-muted mb-4">
      Choose your price and the latest acceptable delivery time<br />
      Please note that due to lockdowns and extremely high freight volumes
      across the industry, delays are occurring with all industry carriers
      including couriers. We apologise for this and are doing our best to
      alleviate the delays. We thank you for your patience, understanding and
      cooperation.
    </p>

    <!-- Offers Delivered by Courier -->
    <p
      v-if="courierRates.length > 0"
      class="t-flex t-text-lg t-font-medium t-mb-2 t--ml-2"
    >
      By Courier
    </p>
    <div class="row delivery-days">
      <!-- Day -->
      <div
        v-for="rate in courierRates"
        :key="rate.id"
        @click.prevent="$emit('rate-selected', rate)"
        class="col-sm-12 col-md-6 col-lg-3 pl-1 pr-1"
      >
        <a
          href="#"
          id="courier-price"
          class="delivery-day text-dark rounded"
          :class="{ active: selected === rate }"
        >
          <div class="delivery-day-body p-2 rounded-top">
            <h3 class="h6">
              {{
                moment(rate.delivery_time, "YYYY-MM-DD HH:mm:ss").format(
                  "ddd D MMM"
                )
              }}
            </h3>
            <p class="text-muted">
              {{
                moment(rate.delivery_time, "YYYY-MM-DD HH:mm:ss").format(
                  "h:mm A"
                )
              }}
            </p>

            <h4 class="h4 text-right m-0">${{ rate.price }}</h4>
          </div>

          <div v-if="rate.fixedRateOffers && showAdminInfo">
            <div
              v-for="offer in rate.fixedRateOffers.data"
              :key="offer.id"
              class="delivery-day-info mt-1 mb-1"
            >
              <admin-delivery-date-info
                :offer="offer"
                v-if="showAdminInfo"
              ></admin-delivery-date-info>
            </div>
          </div>
        </a>
      </div>
    </div>

    <!-- Offers Delivered by Truck -->
    <p class="t-flex t-text-lg t-font-medium t-mb-2 t--ml-2">
      By Truck
    </p>
    <div class="row delivery-days">
      <!-- Day -->
      <div
        v-for="(rate, index) in truckRates"
        :key="rate.id"
        @click.prevent="$emit('rate-selected', rate)"
        class="col-sm-12 col-md-6 col-lg-3 pl-1 pr-1"
      >
        <a
          href="#"
          v-bind:id="'truck-price-'+index"
          class="delivery-day text-dark rounded"
          :class="{ active: selected === rate }"
        >
          <div class="delivery-day-body p-2 rounded-top">
            <h3 class="h6">
              {{
                moment(rate.delivery_time, "YYYY-MM-DD HH:mm:ss").format(
                  "ddd D MMM"
                )
              }}
            </h3>
            <p class="text-muted">
              {{
                moment(rate.delivery_time, "YYYY-MM-DD HH:mm:ss").format(
                  "h:mm A"
                )
              }}
            </p>

            <h4 class="h4 text-right m-0">${{ rate.price }}</h4>
          </div>

          <div v-if="rate.fixedRateOffers && showAdminInfo">
            <div
              v-for="offer in rate.fixedRateOffers.data"
              :key="offer.id"
              class="delivery-day-info mt-1 mb-1"
            >
              <admin-delivery-date-info
                :offer="offer"
                v-if="showAdminInfo"
              ></admin-delivery-date-info>
            </div>
          </div>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import AdminDeliveryDateInfo from "./AdminDeliveryDateInfo";

export default {
  name: "delivery-dates",
  components: {
    AdminDeliveryDateInfo
  },
  props: [
    "selected",
    "rates",
    "pickupRestriction",
    "sameRegion",
    "pricingResponseId"
  ],
  data() {
    return {
      showAdminInfo: false,
      pricingResponse: null,
      courierRates: [],
      truckRates: []
    };
  },
  created() {
    for (let rate of this.rates) {
      if (rate.offer_type === "aramex") {
        this.courierRates.push(rate);
      } else {
        this.truckRates.push(rate);
      }
    }
  },
  methods: {
    moment: function(...args) {
      return moment(...args);
    },

    debug() {
      this.showAdminInfo = true;
    }
  },

  computed: {
    isAdmin() {
      return window.isAdmin;
    }
  }
};
</script>
